import { call, put, takeLatest } from 'redux-saga/effects'

import { FETCH_SUMMARY, fetchSummaryFailure, fetchSummarySuccess } from '../actions'
import { fetchSummaryService, getUserTokenService } from '../services'

export function* watchFetchSummary() {
	yield takeLatest(FETCH_SUMMARY, fetchSummarySaga)
}

function* fetchSummarySaga() {
	try {
		const token = yield call(getUserTokenService)
		const data = yield call(fetchSummaryService, token)
		yield put(fetchSummarySuccess(data))
	} catch (err) {
		yield put(fetchSummaryFailure(err))
	}
}
